/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import moment from 'moment'; 
export default {
  name: 'chat-user-list',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      chatbotList:'',
      userChatDetails:'',
      chatSocket:'',
      userId:'',
      roomChatId:'',
      checkSocketId:'',
      socketCheck:'',
      msgListId:'',
      getUserDetailsID:'',
      listLoading:true
    }
  },
  computed: {
    ...mapGetters([
      'userChatListGetters',
      // 'acUserDetailsStateGetters'
    ]),
    getOrgListDetailsFun(){
      this.chatbotList = this.$store.getters.userChatListGetters.data
      return 
    },
    // getUserDetailsAgainFun(){
    //   this.userId = this.$store.getters.acUserDetailsStateGetters.data
    //   return
    // },
    getCHatUserDetailsAgainFun(){
      if(this.chatbotList != undefined && this.chatbotList.length > 0){
      this.$store.dispatch('getAdminChatDetailsByIdFun', {id:this.chatbotList[0].id}).then((res) => {
        this.userChatDetails = res.data.data
        $('.chat_user_content').first().addClass('show');
        $('.chat_user_listed').first().addClass('active');
        document.querySelector('.chat_user_listed.active').click()
      }).catch((err) => {
      })
      return
      } 
    }
  },
  mounted () {
    this.getOrgListDetailsFun
    this.getCHatUserDetailsAgainFun
    $(document).ready(function(){
        $('#Smallchat').addClass('d-none')
        if(this.userChatDetails != undefined && this.userChatDetails.length > 0){
        setTimeout(()=>{
          $('.chat_user_content').first().addClass('show');
          $('.chat_user_listed').first().addClass('active');
          document.querySelector('.chat_user_listed.active').click()
          var elmnt = document.getElementById("chatbot_scroll");
          var y = elmnt.scrollHeight;
          $('#chatbot_scroll').scrollTop(y)
        },100)}
    })  
    setTimeout(()=>{
      this.listLoading = false
    }, 500)
  },
  methods: {
    dateTimeShown(id){
      $('.msg_shown' + id).parent().toggleClass('time_d_shown')
    },
    socketMsgReadFun(id){
      this.$store.dispatch('msgReadStatusFun', {message_id :id}).then((res)=>{}).catch((err)=>{})
    },
    getUserDetailsFun(id, chatId){
      let userChatListing = '#userChatListingId' + id;
      let userChatDetails = '#userChatDetailsId' + id;
      $('.chat_user_content').removeClass('show');
      $('.chat_user_listed').removeClass('active');
      $(userChatDetails).addClass('show');
      $(userChatListing).addClass('active');
      this.submitted = true
      this.msgListId = id
      var messagesList = document.getElementById('reply_msg_list' + this.msgListId);
      if(chatId != this.getUserDetailsID){
        localStorage.removeItem('adminchatUserInfo')
        this.$store.dispatch('getAdminChatDetailsByIdFun', {id:id}).then((res) => {
          if(res.data.data.length > 0){
          localStorage.setItem('adminchatUserInfo', JSON.stringify(res.data.data[0].chat_room_user.user)
          )
         }
          this.userChatDetails = res.data.data
          $('.recieved_list').remove()
          $('.sent_list').remove()
          if(this.userChatDetails && this.userChatDetails.length > 0){
            this.$store.dispatch('msgReadStatusFun', {message_id : this.userChatDetails.slice(-1)[0].id}).then((res)=>{
            }).catch((err)=>{
            })
          }
          var elmnt = document.getElementById("chatbot_scroll");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
            $('#chatbot_scroll').animate({scrollTop: y},20)
          },100)
        })
      }
      let data = {
        users : [chatId],
        is_support_chat : true
      }
      this.$store.dispatch('chatRoomCreatedFun', data).then((res)=>{
        var chatId = res.data.data.id
        this.getUserDetailsID = res.data.data.to_user
        this.roomChatId = chatId.replace(/-/g, "")
        // console.log( this.roomChatId, this.checkSocketId, chatId, "Socket Status Checked")
        if(this.checkSocketId){
          if(this.roomChatId != this.checkSocketId){
            this.socketCheck.close();
          }
         }
        if(this.roomChatId != this.checkSocketId){
        var socketCheck = new WebSocket(
          'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
          '/ws/chat/' + this.roomChatId + '/'
        );
        this.checkSocketId = socketCheck.url.split('/')[5]
        // console.log(this.checkSocketId, 'Check Admin Room ID')
        this.socketCheck = socketCheck
        socketCheck.onclose = function(e) {
          // console.error(e,'Chat socket closed unexpectedly');
        };
        var _self = this
        socketCheck.onmessage = function(e) {
          // console.log(e.data, "Msg check")
          var data = JSON.parse(e.data);
          var message = JSON.parse(data.message );
          var li = document.createElement("li");
          var span = document.createElement("p");
          span.appendChild(document.createTextNode(message.chat_data.message));
          var time = document.createElement("time");
          let dateTimeAdd = [moment(message.chat_data.created_at).format('MMM DD, YYYY'), + ' '  + moment(message.chat_data.created_at).format('h:mm:ss a')];
          _self.socketMsgReadFun(message.chat_data.message_id)
          time.appendChild(document.createTextNode(dateTimeAdd));
          time.setAttribute("class", "msg_time");
          li.appendChild(span);
          li.appendChild(time);
          li.setAttribute("class", message.chat_data.type + '_list');
          messagesList.appendChild(li);
          var elmnt = document.getElementById("chatbot_scroll");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
          $('#chatbot_scroll').scrollTop(y)
          },100)
        };
        document.querySelector('#chat-message-reply-input').focus();
        document.querySelector('#chat-message-reply-input').onkeyup = function(e) {
            if (e.keyCode === 13) {  // enter, return
                document.querySelector('#chat-message-reply-submit').click();
            }
        };
        document.querySelector('#chat-message-reply-submit').onclick = function(e) {
          var messageInputDom = document.querySelector('#chat-message-reply-input');
          var message = messageInputDom.value; 
          if(message.length > 0){
          var sentUserInfo = _self.userChatDetails[0].chat_room_user.user
          let sentData = {
            'message': message,
            type:'recieved',
            email:sentUserInfo.email,
            name:sentUserInfo.first_name + ' ' + sentUserInfo.last_name,  
          }
          // console.log(JSON.stringify({ 'message': message, 'user':sentUserInfo.id, 'chat_data':sentData}), "Send Msg Checking")
          socketCheck.send(JSON.stringify({ 'message': message, 'user':sentUserInfo.id, 'chat_data':sentData}));
          messageInputDom.value = '';
          var elmnt = document.getElementById("chatbot_scroll");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
          $('#chatbot_scroll').scrollTop(y)
          },100)
          }
        };
        }
      })
    }
  },
  watch:{
    getOrgListDetailsFun(){
      return  this.$store.getters.userChatListGetters
    },
    // getUserDetailsAgainFun(){
    //   return this.$store.getters.acUserDetailsStateGetters.data
    // },
    getCHatUserDetailsAgainFun(){
      if(this.chatbotList != undefined && this.chatbotList.length > 0){
      this.$store.dispatch('getAdminChatDetailsByIdFun', {id:this.chatbotList[0].id}).then((res) => {
        this.userChatDetails = res.data.data
        $('.chat_user_content').first().addClass('show');
        $('.chat_user_listed').first().addClass('active');
        document.querySelector('.chat_user_listed.active').click()
      }).catch((err) => {
      })
      return
      } 
    }
  },
  created(){
      $('.chat_user_content').first().addClass('show');
      $('.chat_user_listed').first().addClass('active');
      // document.querySelector('.chat_user_listed.active').click()
  },
  beforeCreate: function() {
    $('body').addClass('support_chat_reply_page_wrp')
    $('#Smallchat').addClass('d-none')
  },
  beforeRouteLeave: function(to, from, next) {
    $('#Smallchat').removeClass('d-none')
    if(this.socketCheck){
      this.socketCheck.close();
    }
    $('body').removeClass('support_chat_reply_page_wrp')
    next();
  },
}